import React from 'react';

import Tooltip from '@mui/material/Tooltip';

import styled from '../../../styled';
import { colorsPalette } from '../../../theme';

export const LightTooltip = styled(({ className, popperClassName, ...props }) => (
  // @ts-ignore
  <Tooltip {...props} componentsProps={{ tooltip: { className } }} />
))`
  position: relative;
  background-color: ${colorsPalette.violetSecondary};
  border: 1px solid ${colorsPalette.blue};
  color: ${({ theme }) => theme.palette.common.white};
  box-shadow: ${({ theme }) => theme.shadows[1]};
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  font-family: 'sofia-pro', sans-serif;

  &:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    border-top: 5px solid ${colorsPalette.violetSecondary};
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
  }
`;
